module.exports = __webpack_public_path__ + "img/horizontal_4_4_3016.ac60c4d5.png";